<template>
  <div class="card-body p-0" style="margin-bottom:-15px">
    <div v-if="errorMsg" class="text-danger mb-3">{{ errorMsg }}</div>
    <b-form-textarea id="input-label" v-model="replyMessage" rows="4" trim></b-form-textarea>
    <div class="row pl-1 mt-3 modal-footer bg-light text-right">
      <div>
        <b-button variant="info" @click="clickSend()" class="w-25" pill size="sm">
          <b-spinner v-if="savePending === true" small></b-spinner>
          <span v-else>Send</span>
        </b-button>
      </div>
    </div>        
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "../../events/eventBus";

export default {
  props: {
    message: String
  },
  data() {
    return {
      savePending: false,
      errorMsg: null,
      replyMessage: null
    };
  },
  methods: {
    ...mapActions("conversations", ["sendMessage"]),
    async clickSend() {
      if (!this.replyMessage || this.replyMessage === "") {
        this.errorMsg = "Please enter a message.";
        return;
      }

      this.savePending = true;
      await this.sendMessage({message: this.replyMessage, ttsActive: false});
      this.savePending = false;
      EventBus.$emit("close-modal");
    },
  },
  created() {
    this.replyMessage = this.message;
    this.errorMsg = null;
  }
};
</script>


<style scoped>
.stretch-footer {
  margin-left:-16px;
  margin-right:-16px;
  margin-bottom:-16px;
}
</style>